export default __webpack_public_path__ + "static/media/img_upee_b-min.62f56756.jpg";